import { atom } from "jotai";

export const seeMoreCoversStateAtom = atom<boolean>(false);
